const mirutoWorkers = () =>
  (window.MIRUTO_CONFIG && window.MIRUTO_CONFIG.integrations && window.MIRUTO_CONFIG.integrations.workers) ||
  {};

const mirutoGoogleForms = () => {
  const forms =
    window.MIRUTO_CONFIG &&
    window.MIRUTO_CONFIG.integrations &&
    window.MIRUTO_CONFIG.integrations.googleForms;
  if (!forms) return {};
  const { planChangeForm, ...contactForms } = forms;
  return contactForms;
};

class ContactPage {
  constructor() {
    this.$page = $('.contactPage');
    if (!this.$page.length) return;

    // フォームのエンドポイントマッピング（config/{dev,prod}.json → integrations.googleForms）
    this.formEndpoints = { ...mirutoGoogleForms() };

    // フォーム要素の特定
    this.$form = this.$page.find('form');
    this.formId = this.$form.attr('id');

    // フォームの各状態のコンテンツ要素
    this.$inputContent = this.$page.find('[data-state="input"]');
    this.$confirmContent = this.$page.find('[data-state="confirm"]');
    this.$completeContent = this.$page.find('[data-state="complete"]');

    // ボタン要素
    this.$confirmButton = this.$inputContent.find('.--button .c-button');
    this.$editButton = this.$confirmContent.find('.--button .c-button').eq(0);
    this.$submitButton = this.$confirmContent.find('.--button .c-button').eq(1);

    // 表示用とAPI送信用の別々のデータオブジェクトを用意
    this.displayData = {};
    this.formData = {};

    // メール存在チェック状態
    this.emailExists = null;
    this.isCheckingEmail = false;


    this.init();
  }

  init() {
    this.bindEvents();
    this.setupAttachmentWatcher();
    this.detectOrderSource();
    this.setupProductConditionalVisibility();
    this.setupEmailExistCheck();


    // サブスクリプション情報から注文番号を自動入力（現状は prefillFromSubscription() が先頭 return のため no-op）
    this.prefillFromSubscription();
  }

  /**
   * 購入元の特定処理
   */
  detectOrderSource() {
    // 注文番号・購入元inputのjQuery取得
    const $orderInput = $('#contact_order');
    const $storeInput = $('#contact_store');

    const updateStoreName = function() {
      const val = $(this).val().trim();
      let storeName = '';

      if (/^OC-\d{12}-[a-zA-Z0-9]{3}-\d{6}$/.test(val)) {
        storeName = 'サブスクストア';
      } else if (/^\d{3}-\d{7}-\d{7}$/.test(val)) {
        storeName = 'Amazon';
      } else if (/^\d{4,8}$/.test(val)) {
        storeName = 'Shopify';
      } else {
        storeName = 'その他';
      }
      $storeInput.val(storeName);
    };

    $orderInput.on('input change', updateStoreName);
  }

  // 解約製品の選択肢に応じて該当項目を出し分ける
  setupProductConditionalVisibility() {
    const $productSelect = $('#contact_product');

    if (!$productSelect.length) return;

    const toggleFields = (isCatLitter) => {
      const fieldIds = [
        'entry.966699525',     // トラッキング番号
        'entry.1736121538',    // 水洗い
        'entry.379981321',     // 梱包
        'entry.351754600'      // 同梱物
      ];

      fieldIds.forEach(id => {
        const $field = $(`[data-fields="${id}"]`);
        if (isCatLitter) {
          $field.hide();
        } else {
          $field.show();
        }
      });
    };

    // 初期状態でチェック
    const initialValue = $productSelect.val();
    toggleFields(initialValue.includes('ねこ砂'));

    // 値が変更されたらチェック
    $productSelect.on('change', function () {
      const value = $(this).val();
      toggleFields(value.includes('ねこ砂'));
    });
  }

  /**
   * contact_attachment があるページだけ
   * ファイル名抽出の interval を登録
   */
  setupAttachmentWatcher() {
    const input    = document.getElementById('contact_attachment');
    const errorMsg = document.querySelector('.dropboxCheck');
    if (!input || !errorMsg) return;

    setInterval(() => {
      const raw     = input.value;
      const matches = raw.match(/[a-zA-Z0-9_\-]+\.(jpg|jpeg|png|gif|webp)/gi) || [];
      const unique  = [...new Set(matches)];
      input.value   = unique.join(' ');
      errorMsg.style.display = unique.length > 0 ? 'none' : 'block';
    }, 500);
  }

  bindEvents() {
    // フォームのデフォルトの送信を防ぐ
    this.$form.on('submit', (e) => e.preventDefault());

    // 確認ボタンクリック時の処理
    this.$confirmButton.on('click', () => this.handleConfirm());

    // 編集に戻るボタンクリック時の処理
    this.$editButton.on('click', () => this.handleEdit());

    // 送信ボタンクリック時の処理
    this.$submitButton.on('click', () => this.handleSubmit());

    // チェックボックスの特別処理
    this.$form.find('input[type="checkbox"]').on('change', function () {
      const $field = $(this).closest('.contactForm__item');
      const errorMsg = $field.find('.errorMsg');
      if (this.checked) {
        errorMsg.css('display', 'none');
      }
    });
  }

  // 必須項目のバリデーション
  validateRequiredFields() {
    let isValid = true;
    const requiredFields = this.$form.find('.--require');

    requiredFields.each((_, field) => {
      const $field = $(field);
      const input = $field.find('input, textarea, select');
      const errorMsg = $field.find('.errorMsg');
      const value = input.val()?.trim(); // 空チェック用
      const inputType = input.attr('type') || input.prop('tagName').toLowerCase(); // inputタイプまたはタグを取得
      const nameAttr = input.attr('name');

      // 非表示のフィールドはバリデーション対象外にする
      if (!$field.is(':visible')) return;

      if (nameAttr === 'entry.1776017831') return;

      if (inputType === 'checkbox') {
        // チェックボックスのバリデーション
        if (!input.prop('checked')) {
          errorMsg.text('この項目は必須です').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else if (inputType === 'email') {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const inputId = input.attr('id');

        // 確認用メール：形式チェック＋未入力（必須）だけ。存在チェック状態は見ない
        if (inputId === 'contact_email_confirm') {
          if (!value) {
            errorMsg.text('※メールアドレスを入力してください').css('display', 'block');
            isValid = false;
          } else if (!emailPattern.test(value)) {
            errorMsg.text('有効なメールアドレスを入力してください').css('display', 'block');
            isValid = false;
          } else {
            errorMsg.css('display', 'none');
          }
          return;
        }

        // 送信用メール：従来どおり（存在チェック込み）
        if (!emailPattern.test(value)) {
          errorMsg.text('有効なメールアドレスを入力してください').css('display', 'block');
          isValid = false;
        } else if (this.isCheckingEmail) {
          errorMsg.text('メールアドレスを確認中です。少しお待ちください。').css('display', 'block');
          isValid = false;
        } else if (this.emailExists === false) {
          errorMsg.text('ご登録のないメールアドレスです。レンタル時に登録したメールアドレスをご入力ください。').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }

        return;

      } else if (inputType === 'tel') {
        const errorMsgText = (msg) => errorMsg.text(msg).css('display', 'block');

        const numericPattern = /^[0-9]+$/;
        const phonePattern = /^0\d{9,10}$/;

        if (!value) {
          errorMsgText('電話番号を入力してください');
          isValid = false;
        } else if (!numericPattern.test(value)) {
          errorMsgText('電話番号には数字のみを入力してください（ハイフンは不要です）');
          isValid = false;
        } else if (!phonePattern.test(value)) {
          errorMsgText('有効な電話番号を入力してください');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else if (inputType === 'radio') {
        // ラジオボタンのバリデーション
        if (input.filter(":checked").length == 0) {
          errorMsg.text('この項目は必須です').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else if (inputType === 'select') {
        // セレクトボックスのバリデーション
        if (!value || value === '選択してください' || value === '読み込み中...') {
          if (nameAttr === 'productName') {
            errorMsg.text('※製品名を選択してください').css('display', 'block');
          } else if (nameAttr === 'orderNumber') {
            errorMsg.text('※注文番号を選択してください').css('display', 'block');
          } else if (nameAttr === 'inquiryCategory') {
            errorMsg.text('※カテゴリを選択してください').css('display', 'block');
          } else {
            errorMsg.text('この項目は必須です').css('display', 'block');
          }
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else {
        // 必須項目のバリデーション (共通)
        if (!value || value === '選択してください') {
          // 注文番号だけ文言を変えたい場合
          if (nameAttr === 'orderNumber') {
            errorMsg.text('※注文番号を入力してください').css('display', 'block');
          } else {
            errorMsg.text('この項目は必須です').css('display', 'block');
          }
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      }
    });

    const input = document.getElementById('contact_attachment');
    const errorMsg = document.querySelector('.dropboxCheck');

    if (input && errorMsg) {
      setInterval(() => {
        const rawValue = input.value;
        const matches = rawValue.match(/[a-zA-Z0-9_\-]+\.(jpg|jpeg|png|gif|webp)/gi) || [];
        const uniqueFilenames = [...new Set(matches)];
        input.value = uniqueFilenames.join(' ');

        if (uniqueFilenames.length > 0) {
          errorMsg.style.display = 'none';
        } else {
          errorMsg.style.display = 'block';
        }
      }, 500);
    }

    const attachmentInput = document.getElementById('contact_attachment');
    const attachmentErrorMsg = attachmentInput?.parentElement.querySelector('.errorMsg');

    if (attachmentInput && attachmentErrorMsg) {
      const fileNames = attachmentInput.value.trim();
      if (!fileNames) {
        attachmentErrorMsg.style.display = 'block';
        isValid = false;
      } else {
        attachmentErrorMsg.style.display = 'none';
      }
    }

    // ============================
    // 追加：送信用メールと確認用メールの一致チェック
    // ============================
    const $mainEmail = this.$form.find('#contact_email');
    const $confirmEmail = this.$form.find('#contact_email_confirm');

    if ($mainEmail.length && $confirmEmail.length && $confirmEmail.closest('.contactForm__item').is(':visible')) {
      const mainVal = ($mainEmail.val() || '').trim();
      const confirmVal = ($confirmEmail.val() || '').trim();

      const $confirmField = $confirmEmail.closest('.contactForm__item');
      const $confirmError = $confirmField.find('.errorMsg');

      // main は required 側で空チェックされる前提だが、念のため
      if (mainVal && confirmVal && mainVal !== confirmVal) {
        $confirmError
          .text('※メールアドレスが一致しません。再入力してください')
          .css('display', 'block');
        isValid = false;
      }
    }

    return isValid;
  }

  // ログイン済みユーザーのサブスクリプション情報を取得して注文番号欄を自動入力
  async prefillFromSubscription() {
    // purchaseForm の注文番号自動入力は bundle.js の purchaseFormSubscription.js が担当するため、
    // ここでは何もしない（二重処理で #contact_order が競合するのを防ぐ）
    return;
    // 買い切り申請フォームのみ動作
    if (this.formId !== 'purchaseForm') return;

    const customerId = this.$page[0]?.dataset?.customerId;
    if (!customerId) return;

    const baseUrl = mirutoWorkers().subscriptionStatus;
    if (!baseUrl) return;

    // ── 買い切り申請フォーム 対象プラン設定 ────────────────────────────────
    // catalog.purchaseProducts（productKey → sellingPlanIds）で製品別にプランを識別する。
    // variantId は古い商品の情報が不明なため sellingPlanId を優先。
    // API が sellingPlanId を返さない場合は debugOrders.line_items.variant_id でフォールバック。
    // 対象プランが変わった場合は config/dev.json / config/prod.json を編集して
    // make config FLAVOR=dev|prod を実行してください。
    const purchaseProductsConfig = window.MIRUTO_CONFIG?.catalog?.purchaseProducts;
    // sellingPlanId → productKey
    const PURCHASE_SELLING_PLAN_MAP = new Map();
    if (purchaseProductsConfig && typeof purchaseProductsConfig === 'object') {
      for (const [key, conf] of Object.entries(purchaseProductsConfig)) {
        for (const spid of (conf.sellingPlanIds || [])) PURCHASE_SELLING_PLAN_MAP.set(String(spid), key);
      }
    }
    // variantId → productKey（planChangeProducts + subscriptionProducts から構築）
    const PURCHASE_VARIANT_MAP = new Map();
    const planChangeConfig = window.MIRUTO_CONFIG?.catalog?.planChangeProducts;
    if (planChangeConfig && typeof planChangeConfig === 'object') {
      for (const [key, conf] of Object.entries(planChangeConfig)) {
        for (const vid of (conf.variantIds || [])) PURCHASE_VARIANT_MAP.set(String(vid), key);
      }
    }
    const subscriptionProductsConfig = window.MIRUTO_CONFIG?.catalog?.subscriptionProducts;
    if (subscriptionProductsConfig && typeof subscriptionProductsConfig === 'object') {
      for (const [key, vid] of Object.entries(subscriptionProductsConfig)) {
        if (!PURCHASE_VARIANT_MAP.has(String(vid))) PURCHASE_VARIANT_MAP.set(String(vid), key);
      }
    }

    // 製品名セレクト値 → productKey（テンプレートの option_values と一致させること）
    const PRODUCT_SELECT_TO_KEY = {
      '全自動スマートトイレ モデルLala（2026年モデル）': 'lala',
      '全自動スマートトイレ モデルCoco（2024年モデル）': 'coco',
      '全自動スマートトイレ モデルMimi（2023年モデル）': 'mimi',
      'モニタリング自動給水器 モデルMona(2024年モデル)':               'mona',
    };

    // 注文番号欄をプレースホルダー select に差し替えるヘルパー
    const showOrderFieldPlaceholder = (message) => {
      const $current = this.$form.find('#contact_order');
      if (!$current.length) return;
      const name = $current.attr('name') || 'orderNumber';
      const id   = $current.attr('id')   || 'contact_order';
      const cls  = $current.attr('class') || '';
      const select = document.createElement('select');
      select.name = name; select.id = id; select.className = cls;
      select.disabled = true;
      select.dataset.loading = '1';
      const opt = document.createElement('option');
      opt.value = ''; opt.textContent = message; opt.selected = true;
      select.appendChild(opt);
      $current[0].replaceWith(select);
    };

    // fetch 開始前にロード中表示
    showOrderFieldPlaceholder('注文番号取得中...');

    try {
      const res = await fetch(`${baseUrl}/user-subscription-status`);
      if (!res.ok) { showOrderFieldPlaceholder('注文番号の取得に失敗しました'); return; }
      const raw = await res.json();
      if (!raw?.subscriptions) { showOrderFieldPlaceholder('注文番号の取得に失敗しました'); return; }

      // orderId → 注文番号 / debugOrder マップを構築
      const orderNameMap  = new Map();
      const debugOrderMap = new Map();
      if (Array.isArray(raw.debugOrders)) {
        for (const o of raw.debugOrders) {
          if (o.id == null) continue;
          const oid  = String(o.id);
          const name = o.name ? String(o.name).replace(/^#/, '') : oid;
          orderNameMap.set(oid, name);
          debugOrderMap.set(oid, o);
        }
      }

      // 有効なサブスクリプションを抽出（buyout-completed を除外）
      // eligibleOrders[].productKey: 製品キー（lala/coco/mimi/mona）
      const eligibleOrders = [];
      for (const [orderId, subData] of Object.entries(raw.subscriptions)) {
        // タグ取得（subData.tags 優先、なければ debugOrders からフォールバック）
        let tags = [];
        if (subData.tags != null && subData.tags !== '') {
          tags = Array.isArray(subData.tags)
            ? subData.tags
            : typeof subData.tags === 'string'
            ? subData.tags.split(',').map(t => t.trim())
            : [];
        } else {
          const debugOrder = debugOrderMap.get(String(orderId));
          if (debugOrder?.tags) {
            tags = Array.isArray(debugOrder.tags)
              ? debugOrder.tags
              : typeof debugOrder.tags === 'string'
              ? debugOrder.tags.split(',').map(t => t.trim())
              : [];
          }
        }
        if (tags.includes('buyout-completed')) continue;

        // 1. subData.items の sellingPlanId でマッチ（API が ID を返す場合のメインパス）
        let productKey = null;
        for (const item of (subData.items || [])) {
          const sellingPlanId = item.sellingPlanId ?? item.selling_plan_id ?? item.sellingPlanID ?? null;
          if (sellingPlanId != null && PURCHASE_SELLING_PLAN_MAP.has(String(sellingPlanId))) {
            productKey = PURCHASE_SELLING_PLAN_MAP.get(String(sellingPlanId));
            break;
          }
        }

        // 2. debugOrders.line_items.variant_id でフォールバック
        if (productKey === null) {
          const isSubscriptionOrder = tags.some(t => t.startsWith('subscription-id:'));
          if (isSubscriptionOrder) {
            const debugOrder = debugOrderMap.get(String(orderId));
            for (const li of (debugOrder?.line_items || [])) {
              const vid = li.variant_id ?? li.variantId ?? null;
              if (vid != null && PURCHASE_VARIANT_MAP.has(String(vid))) {
                productKey = PURCHASE_VARIANT_MAP.get(String(vid));
                break;
              }
            }
            // sellingPlanId でも variant でも特定できない場合は対象外としてスキップ
            if (productKey === null) continue;
          }
        }

        if (productKey === null) continue;
        eligibleOrders.push({ orderId: String(orderId), productKey });
      }

      // 製品選択後に注文番号 select を更新する関数
      const updateOrderField = (selectedProductKey) => {
        if (selectedProductKey === null) {
          showOrderFieldPlaceholder('製品名を選択してください');
          return;
        }

        const $current   = this.$form.find('#contact_order');
        const $orderItem = $current.closest('.contactForm__item');
        const $errorMsg  = $orderItem.find('.errorMsg');
        const name = $current.attr('name') || 'orderNumber';
        const id   = $current.attr('id')   || 'contact_order';
        const cls  = $current.attr('class') || '';

        // 製品キーでフィルタリング
        const orders = eligibleOrders.filter(o => o.productKey === selectedProductKey);

        const select = document.createElement('select');
        select.name = name; select.id = id; select.className = cls;

        if (orders.length === 0) {
          const opt = document.createElement('option');
          opt.value = ''; opt.textContent = '対象の注文が存在しません';
          opt.disabled = true; opt.selected = true;
          select.appendChild(opt);
          select.disabled = true;
          select.dataset.noOrders = '1';
          $errorMsg.text('対象の注文が存在しません').css('display', 'block');
        } else {
          const placeholder = document.createElement('option');
          placeholder.value = ''; placeholder.textContent = '選択してください';
          placeholder.disabled = true; placeholder.selected = true;
          select.appendChild(placeholder);

          for (const { orderId } of orders) {
            const orderNumber = orderNameMap.get(orderId) || orderId;
            const opt = document.createElement('option');
            opt.value = orderNumber; opt.textContent = `#${orderNumber}`;
            select.appendChild(opt);
          }
          if (orders.length === 1) select.selectedIndex = 1;
          $errorMsg.css('display', 'none');
        }
        $current[0].replaceWith(select);
      };

      // fetch 完了後は製品選択待ち表示
      showOrderFieldPlaceholder('製品名を選択してください');

      // 製品名選択 → 注文番号欄を更新（多重登録防止）
      this.$form.off('change.purchaseProduct').on('change.purchaseProduct', '#contact_product', (e) => {
        const productKey = PRODUCT_SELECT_TO_KEY[e.target.value] ?? null;
        updateOrderField(productKey);
      });

      // 既に製品が選択済みなら即反映
      const alreadySelected = this.$form.find('#contact_product').val();
      if (alreadySelected && alreadySelected !== '選択してください') {
        updateOrderField(PRODUCT_SELECT_TO_KEY[alreadySelected] ?? null);
      }
    } catch (e) {
      console.error('[BuyoutForm] prefillFromSubscription error:', e);
      showOrderFieldPlaceholder('注文番号の取得に失敗しました');
    }
  }

  // 入力されたEmailアドレスの存在チェック
  setupEmailExistCheck() {
    // 買い切り申請フォームで動作
    if (this.formId !== 'purchaseForm') return;

    const $emailInput = this.$form.find('#contact_email');
    if (!$emailInput.length) return;

    const $field = $emailInput.closest('.contactForm__item');
    const $errorMsg = $field.find('.errorMsg');

    // ステータスメッセージ用要素を追加
    let $statusMsg = $field.find('.emailCheckMsg');
    if (!$statusMsg.length) {
      $statusMsg = $('<p class="emailCheckMsg" style="margin-top:4px;font-size:12px;"></p>');
      $statusMsg.insertAfter($errorMsg);
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    let timer = null;
    const endpoint = mirutoWorkers().emailCheck;

    const execCheck = (email) => {
      if (!emailPattern.test(email)) {
        this.emailExists = null;
        $statusMsg.text('').hide();
        return;
      }

      this.isCheckingEmail = true;
      this.emailExists = null;

      $statusMsg
        .text('メールアドレスを確認しています…')
        .css('color', '#6a676b')
        .show();

      fetch(`${endpoint}?email=${encodeURIComponent(email)}`)
        .then(res => res.json())
        .then(data => {
          if (data && data.exists === true) {
            this.emailExists = true;
            $statusMsg
              .text('このメールアドレスはレンタル時に登録されたメールアドレスです。')
              .css('color', '#008000')
              .show();
          } else if (data && data.exists === false) {
            this.emailExists = false;
            $statusMsg
              .text('ご登録のないメールアドレスです。レンタル時に登録したメールアドレスをご入力ください。')
              .css('color', '#ef857d')
              .show();
          } else {
            this.emailExists = null;
            $statusMsg
              .text('メールアドレスの確認に失敗しました。時間をおいて再度お試しください。')
              .css('color', '#ef857d')
              .show();
          }
        })
        .catch(() => {
          this.emailExists = null;
          $statusMsg
            .text('メールアドレスの確認に失敗しました。時間をおいて再度お試しください。')
            .css('color', '#ef857d')
            .show();
        })
        .finally(() => {
          this.isCheckingEmail = false;
        });
    };

    // 入力が止まって 500ms 後 or blur でチェック
    $emailInput.on('input', () => {
      const email = $emailInput.val().trim();

      if (timer) clearTimeout(timer);
      timer = setTimeout(() => execCheck(email), 500);
    });

    $emailInput.on('blur', () => {
      const email = $emailInput.val().trim();
      if (!email) return;
      execCheck(email);
    });
  }

  /**
   * 名前・電話・メール・注文番号が Shopify 注文と一致するかを Workers でチェック
   * - true  : OK（確認画面へ進める）
   * - false : NG（注文番号欄にエラー表示）
   */
  async validateOrderAndCustomer() {
    // 買い切り申請フォーム以外では何もしない
    if (this.formId !== 'purchaseForm') return true;

    const $nameInput  = this.$form.find('#contact_name');
    const $telInput   = this.$form.find('input[type="tel"]');
    const $emailInput = this.$form.find('#contact_email');
    const $orderInput = this.$form.find('#contact_order');

    if (!$orderInput.length) return true; // 念のため

    const name  = $nameInput.val()?.trim()  || '';
    const phone = $telInput.val()?.trim()   || '';
    const email = $emailInput.val()?.trim() || '';
    const order = $orderInput.val()?.trim() || '';

    const $orderField    = $orderInput.closest('.contactForm__item');
    const $orderErrorMsg = $orderField.find('.errorMsg');

    // 「不明」または空欄はここではチェックしない（必須チェック側に任せる）
    if (!order || order === '不明') {
      // 念のためエラーメッセージを消しておく
      // （必須エラーは validateRequiredFields() が出す）
      if (order && order === '不明') {
        // 不明でも OK というメッセージを出したければここで
        // $orderErrorMsg.text('注文番号が不明の場合は「不明」で送信いただけます。').css('display', 'block');
      }
      return true;
    }

    // ▼ ここから追加：数字のみの場合は「4桁以上」でないとエラーにする
    // 全角数字は半角に、ハイフンなどは除外して長さを確認
    const numericOnly = order
      .replace(/[０-９]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFF10 + 0x30)) // 全角 → 半角
      .replace(/\D/g, ''); // 数字以外を除去

    // 「数字だけで構成されている & 4桁未満」の場合は形式エラー
    if (/^[0-9０-９]+$/.test(order) && numericOnly.length > 0 && numericOnly.length < 4) {
      $orderErrorMsg
        .text('注文番号は4桁以上の数字で入力してください。（例：1001）')
        .css('display', 'block');
      return false;
    }

    // Workers のエンドポイント
    const endpoint =
      mirutoWorkers().orderValidate;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_number: order,
          name,
          phone,
          email,
        }),
      });

      const data = await res.json().catch(() => null);

      if (!data || data.valid !== true) {
        const reason = data && data.reason;

        if (reason === 'order_not_found') {
          $orderErrorMsg
            .text('この注文番号のご注文が見つかりません。注文確認メールまたはマイページから注文番号をご確認ください。')
            .css('display', 'block');
        } else if (reason === 'buyout_completed') {
          $orderErrorMsg
            .text('このご注文はすでに買い切り精算が完了しています。本フォームからの再申請は不要です。')
            .css('display', 'block');
        } else {
          $orderErrorMsg
            .text('入力されたお名前・電話番号・メールアドレスと注文番号の組み合わせが確認できませんでした。ご注文情報をご確認のうえ、再度ご入力ください。')
            .css('display', 'block');
        }

        return false;
      }

      // OK の場合はエラーを消す
      $orderErrorMsg.css('display', 'none');
      return true;
    } catch (e) {
      console.error('order validate error', e);
      // 通信エラー時は、とりあえず通す or 止めるかは運用ポリシー次第
      // 今回は「念のため止める」ほうが安全そう
      $orderErrorMsg
        .text('注文番号の確認に失敗しました。時間をおいて再度お試しください。')
        .css('display', 'block');
      return false;
    }
  }

  // フォームデータの収集
  collectFormData() {
    const formData = new FormData(this.$form[0]);
    this.displayData = {};
    this.formData = {};

    for (const [key, value] of formData.entries()) {
      // 確認用メールは送信しない（Googleフォーム項目なし）
      if (key === 'email_confirm') {
        continue;
      }

      if (value instanceof File) continue;

      // 日付フィールドの処理
      if (key.includes('entry.') && value.includes('-')) {
        const isPotentialDate = /^\d{4}-\d{2}-\d{2}$/.test(value);
        if (isPotentialDate) {
          try {
            const date = new Date(value);
            // 元のキーから年月日のキーを生成
            const baseKey = key.split('_')[0];

            // Google Forms送信用データ
            this.formData[`${baseKey}_year`] = date.getFullYear().toString();
            this.formData[`${baseKey}_month`] = (date.getMonth() + 1).toString();
            this.formData[`${baseKey}_day`] = date.getDate().toString();

            // 確認画面表示用データ
            this.displayData[key] = `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;
          } catch (e) {
            console.error('Date parsing error:', e);
            this.displayData[key] = value;
          }
        } else {
          // 日付形式でない場合（住所など）
          this.displayData[key] = value;
          this.formData[key] = value;
        }
      } else if (key.includes('entry.') && this.$form.find(`[name="${key}"]`).attr('type') === 'checkbox') {
        // チェックボックスの処理
        const $checkbox = this.$form.find(`[name="${key}"]`);
        if ($checkbox.prop('checked')) {
          const caption = $checkbox.next('label').text();
          const checkboxValue = $checkbox.val(); // value属性の値を取得
          this.displayData[key] = caption;      // 表示用にはキャプションを使用
          this.formData[key] = checkboxValue;   // 送信用にはvalue属性の値を使用
        }
      } else {
        // その他のフィールド
        this.formData[key] = value;
        this.displayData[key] = value;
      }
    }

    // デバッグ用：グローバルに公開
    window.contactData = {
      displayData: this.displayData,
      formData: this.formData
    };

    // デバッグ用：コンソールに出力
    console.log('Display Data:', this.displayData);
    console.log('Form Data to be sent:', this.formData);
  }

  // 確認画面にデータを表示
  displayConfirmData() {
    const confirmFields = this.$confirmContent.find('.contactForm__item');

    confirmFields.each((_, field) => {
      const $field = $(field);
      const fieldName = $field.data('fields');
      const confirmContent = $field.find('.confirm_content');

      if (fieldName && this.displayData[fieldName]) {
        confirmContent.text(this.displayData[fieldName]);
      }
    });
  }

  // Google Formsへのデータ送信
  async submitToGoogleForms() {
    const formUrl = this.formEndpoints[this.formId];
    if (!formUrl) {
      console.error('Form endpoint not found');
      return false;
    }

    try {
      await fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(this.formData),
      });

      return true;
    } catch (error) {
      console.error('Form submission error:', error);
      return false;
    }
  }

  // Zendesk（Cloudflare Workers経由）へのデータ送信
  async submitToZendesk() {
    const ENDPOINT_MAP = {
      purchaseForm: mirutoWorkers().purchaseFormSubmit,
      inquiryForm:  mirutoWorkers().inquiryFormSubmit,
    };
    const endpoint = ENDPOINT_MAP[this.formId];
    if (!endpoint) {
      console.error('Zendesk worker endpoint not configured for:', this.formId);
      return false;
    }

    const PAYLOAD_MAP = {
      purchaseForm: {
        name:        this.formData['name'],
        email:       this.formData['email'],
        phone:       this.formData['phone'],
        productName: this.formData['productName'],
        orderNumber: this.formData['orderNumber'],
      },
      inquiryForm: {
        name:            this.formData['name'],
        email:           this.formData['email'],
        phone:           this.formData['phone'],
        inquiryCategory: this.formData['inquiryCategory'],
        productName:     this.formData['productName'],
        description:     this.formData['content'],
      },
    };

    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(PAYLOAD_MAP[this.formId]),
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        console.error('Zendesk worker error:', response.status, errorBody);
        return false;
      }
      return true;
    } catch (error) {
      console.error('Zendesk submission error:', error);
      return false;
    }
  }

  // 確認ボタン処理
  async handleConfirm() {
    const $buttonErrorMsg = this.$inputContent.find('.--button .errorMsg');

    // 1. 必須チェック
    if (!this.validateRequiredFields()) {
      $buttonErrorMsg.css('display', 'block');
      return;
    }

    // 2. 注文番号＋顧客情報の照合（買い切りフォームのみ実行）
    const isOrderValid = await this.validateOrderAndCustomer();
    if (!isOrderValid) {
      // 注文番号欄にエラーが出ているのでボタン下にもエラーを出しておく
      $buttonErrorMsg.css('display', 'block');
      return;
    }

    // 3. すべて OK → 確認画面へ
    $buttonErrorMsg.hide();

    this.collectFormData();
    this.displayConfirmData();

    this.$inputContent.css('display', 'none');
    this.$confirmContent.css('display', 'block');

    console.log('=== Confirmation Data ===');
    console.log('Data to be displayed:', window.contactData.displayData);
    console.log('Data to be sent:', window.contactData.formData);

    window.scrollTo(0, 0);
  }


  // 編集に戻る処理
  handleEdit() {
    this.$confirmContent.css('display', 'none');
    this.$inputContent.css('display', 'block');

    // ページトップにスクロール
    window.scrollTo(0, 0);
  }

  // 送信処理
  async handleSubmit() {
    this.$submitButton.prop('disabled', true);

    let success;
    if (this.formId === 'purchaseForm' || this.formId === 'inquiryForm') {
      success = await this.submitToZendesk();
    } else {
      success = await this.submitToGoogleForms();
    }

    this.$submitButton.prop('disabled', false);

    if (success) {
      this.$confirmContent.css('display', 'none');
      this.$completeContent.css('display', 'block');

      // ページトップにスクロール
      window.scrollTo(0, 0);

      // フォームをリセット
      this.$form[0].reset();
    } else {
      alert('送信に失敗しました。もう一度お試しください。');
    }
  }
}

// インスタンス化
document.addEventListener('DOMContentLoaded', () => {
  new ContactPage();
});